import { ref } from 'vue';

export type ButtonPosition = 'top-right' | 'bottom-right';

const isVisible = ref(false);
const buttonPosition = ref<ButtonPosition>('top-right');
export function useSupportBtn() {
  function show(buttonPositionArg: ButtonPosition, delayMs = 0) {
    setTimeout(() => {
      isVisible.value = true;
      buttonPosition.value = buttonPositionArg;
    }, delayMs);
  }

  function hide() {
    isVisible.value = false;
  }

  return {
    isVisible,
    buttonPosition,
    show,
    hide,
  };
}
